export enum MediaTypeEnum {
    NotSet = 0,
    Dynamic = 1,
    StaticFile = 2,
    Newsletter = 3
}
